import { createFileRoute } from '@tanstack/react-router';
import { EcranRevue } from '../revue/EcranRevue';

export const Route = createFileRoute('/revue')({
  component: EcranRevue,
});
